module.exports = __webpack_public_path__ + "img/logo-wandr_e.f322a13a.svg";